import { ChildOfSubFormatArray, FormatArray, GrandChildOfSubFormatArray, SubFormatArray } from "../../Utils/utils";
import { sessionReportSubtitle, sessionReportTitle } from "./SessionReport";

const NonMentalSessionSummary = ({ sessionSummaryGeneralData,sessionSummarySudData }: any) => {
    return (
        <>
            <span
                className="session_report_title"
                style={sessionReportTitle}
            >
                SOAP Note Summary
            </span>
            <ul>
                <li style={sessionReportSubtitle}>Subjective:</li>
                <SubFormatArray
                    subIndex={"sex"}
                    keyName="Sex"
                    value={sessionSummaryGeneralData?.["sex"] || []}
                />
                <SubFormatArray
                    subIndex={"age"}
                    keyName="Age"
                    value={sessionSummaryGeneralData?.["age"] || []}
                />
                <SubFormatArray
                    subIndex={"chief_complaint"}
                    keyName="Chief Complaint (CC)"
                    value={
                        sessionSummaryGeneralData?.[
                        "chief_complaint"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"history_of_present_illness"}
                    keyName="History of Present Illness (HPI)"
                    value={
                        sessionSummaryGeneralData?.[
                        "history_of_present_illness"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"change_since_last_vist"}
                    keyName="Changes Since Last Visit"
                    value={
                        sessionSummaryGeneralData?.[
                        "interval_history"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"history"}
                    keyName="History"
                    value={" "}
                />
                <ChildOfSubFormatArray
                    subIndex={"psychiatric_history"}
                    keyName="Psychiatric History"
                    value={
                        sessionSummaryGeneralData?.[
                        "past_psychiatric_history"
                        ] || []
                    }
                />
                <ChildOfSubFormatArray
                    subIndex={"cognitive_history"}
                    keyName="Cognitive History"
                    value={
                        sessionSummaryGeneralData?.[
                        "cognitive_history"
                        ] || []
                    }
                />
                <ChildOfSubFormatArray
                    subIndex={"childhood_trauma"}
                    keyName="Childhood Trauma"
                    value={
                        sessionSummaryGeneralData?.["child_trauma"] ||
                        []
                    }
                />
                <ChildOfSubFormatArray
                    subIndex={"social_history"}
                    keyName="Social History"
                    value={" "}
                />
                <GrandChildOfSubFormatArray
                    subIndex={"home_and_environment"}
                    keyName={"Home and Environment"}
                    values={[
                        sessionSummaryGeneralData?.["relationship"],
                        sessionSummaryGeneralData?.["friends"],
                        sessionSummaryGeneralData?.["support_system"],
                        sessionSummaryGeneralData?.["stress_level"],
                        sessionSummaryGeneralData?.["trigger"] || [],
                    ]}
                />
                <GrandChildOfSubFormatArray
                    subIndex={"education"}
                    keyName={"Education"}
                    values={
                        sessionSummaryGeneralData?.["education"] || []
                    }
                />
                <GrandChildOfSubFormatArray
                    subIndex={"employment"}
                    keyName={"Employment"}
                    values={
                        sessionSummaryGeneralData?.["employment"] || []
                    }
                />
                <GrandChildOfSubFormatArray
                    subIndex={"eating_and_sleeping"}
                    keyName={"Eating and Sleep"}
                    values={[
                        sessionSummaryGeneralData?.[
                        "diet_and_nutrition"
                        ],
                        sessionSummaryGeneralData?.["sleep_pattern"] ||
                        [],
                    ]}
                />
                <GrandChildOfSubFormatArray
                    subIndex={"activities"}
                    keyName={"Activities"}
                    values={[
                        sessionSummaryGeneralData?.[
                        "physical_activity"
                        ],
                        sessionSummaryGeneralData?.["energy_level"],
                        sessionSummaryGeneralData?.[
                        "hobbies_and_interests"
                        ] || [],
                    ]}
                />
                <GrandChildOfSubFormatArray
                    subIndex={"drugs"}
                    keyName={"Drugs"}
                    values={[
                        sessionSummarySudData?.["substance"],
                        sessionSummarySudData?.["secondary_substances"],
                        sessionSummarySudData?.["substance_start"],
                        sessionSummarySudData?.["frequency"],
                        sessionSummarySudData?.["administration"],
                        sessionSummaryGeneralData?.["overdose"] || [],
                    ]}
                />
                <GrandChildOfSubFormatArray
                    subIndex={"suicide"}
                    keyName={"Suicide"}
                    values={[
                        sessionSummaryGeneralData?.["suicide_attempt"],
                        sessionSummaryGeneralData?.[
                        "suicide_ideation"
                        ] || [],
                    ]}
                />
                <ChildOfSubFormatArray
                    subIndex={"medical_surgical_history"}
                    keyName="Medical/Surgical History"
                    value={
                        sessionSummaryGeneralData?.[
                        "past_medical_history"
                        ] || []
                    }
                />
                <ChildOfSubFormatArray
                    subIndex={"medical_family_history"}
                    keyName="Medical Family History"
                    value={
                        sessionSummaryGeneralData?.[
                        "family_history_medical"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"review_of_system"}
                    keyName="Review of Systems (ROS)"
                    value={
                        sessionSummaryGeneralData?.[
                        "review_of_systems"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"current_medications"}
                    keyName="Current Medications"
                    value={
                        sessionSummaryGeneralData?.[
                        "medication_review"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"allergies"}
                    keyName="Allergies"
                    value={
                        sessionSummaryGeneralData?.["allergies"] || []
                    }
                />
                <li style={sessionReportSubtitle}>Objective:</li>
                <SubFormatArray
                    subIndex={"vital_signs"}
                    keyName="Vital Signs, Physical Exam, and Mental Status Examination"
                    value={
                        sessionSummaryGeneralData?.[
                        "physical_examination"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"psychiatric"}
                    keyName="Psychiatric, Psychological, or Cognitive Tests"
                    value={
                        sessionSummaryGeneralData?.["framework"] || []
                    }
                />
                <SubFormatArray
                    subIndex={"laboratory_tests"}
                    keyName="Laboratory Tests"
                    value={
                        sessionSummaryGeneralData?.["allergies"] || []
                    }
                />
                <SubFormatArray
                    subIndex={"medical_problems"}
                    keyName={"Medical Problems"}
                    value={[
                        sessionSummaryGeneralData?.["liver_problem"],
                        sessionSummaryGeneralData?.["heart_problem"],
                        sessionSummaryGeneralData?.["thyroid_problem"],
                        sessionSummaryGeneralData?.["adrenal_problem"],
                        sessionSummaryGeneralData?.[
                        "neurological_problem"
                        ],
                        sessionSummaryGeneralData?.[
                        "inflammatory_autoimmune_problem"
                        ],
                        sessionSummaryGeneralData?.[
                        "hormonal_imbalances"
                        ],
                        sessionSummaryGeneralData?.[
                        "gastrointestinal_problem"
                        ],
                        sessionSummaryGeneralData?.[
                        "diabetes_mellitus"
                        ],
                        sessionSummaryGeneralData?.[
                        "diabetes_mellitus"
                        ],
                        sessionSummaryGeneralData?.[
                        "vitamin_deficiency"
                        ] || [],
                    ]}
                />
                <li style={sessionReportSubtitle}>Assesment:</li>
                <SubFormatArray
                    subIndex={"primary_diagnosis"}
                    keyName="Primary Diagnosis"
                    value={
                        sessionSummaryGeneralData?.["diagnosis"] || []
                    }
                />
                <SubFormatArray
                    subIndex={"diffential_diagnosis"}
                    keyName="Differential Diagnosis"
                    value={
                        sessionSummaryGeneralData?.["assessment"] || []
                    }
                />
                <SubFormatArray
                    subIndex={"risk_factor"}
                    keyName="Risk Factor Assessment"
                    value={
                        sessionSummaryGeneralData?.[
                        "risk_factor_assessment"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"safety_and_legal"}
                    keyName="Safety and Legal Concerns"
                    value={" "}
                />
                <ChildOfSubFormatArray
                    subIndex={"access_to_firearms"}
                    keyName="Access to Firearms"
                    value={
                        sessionSummaryGeneralData?.["firearm"] || []
                    }
                />
                <ChildOfSubFormatArray
                    subIndex={"unsafe_environment"}
                    keyName="Unsafe Living Environment"
                    value={
                        sessionSummaryGeneralData?.["safety"] || []
                    }
                />
                <ChildOfSubFormatArray
                    subIndex={"history_of_violence"}
                    keyName="History of Violence"
                    value={
                        sessionSummaryGeneralData?.["violence"] || []
                    }
                />
                <ChildOfSubFormatArray
                    subIndex={"legal_issues"}
                    keyName="Legal Issues"
                    value={
                        sessionSummaryGeneralData?.["legal_problem"] ||
                        []
                    }
                />
                <li style={sessionReportSubtitle}>Plan:</li>
                <SubFormatArray
                    subIndex={"management_plan"}
                    keyName="Management Plan"
                    value={sessionSummaryGeneralData?.["plan"] || []}
                />
                <SubFormatArray
                    subIndex={"laboratory"}
                    keyName="Laboratory"
                    value={
                        sessionSummaryGeneralData?.["lab_work"] || []
                    }
                />
                <SubFormatArray
                    subIndex={"special_considerations"}
                    keyName="Special Considerations"
                    value={" "}
                />
                <ChildOfSubFormatArray
                    subIndex={"insurance"}
                    keyName="Insurance"
                    value={
                        sessionSummaryGeneralData?.["insurance"] || []
                    }
                />
                <ChildOfSubFormatArray
                    subIndex={"pregnancy"}
                    keyName="Pregnancy"
                    value={
                        sessionSummaryGeneralData?.["pregnancy"] || []
                    }
                />
            </ul>
            <span
                className="session_report_title"
                style={sessionReportTitle}
            >
                Detailed Summary
            </span>
            <br />
            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                General Information
            </span>
            <ul>
                <FormatArray
                    subIndex={"purpose_of_visit"}
                    keyName="Purpose of Visit"
                    value={
                        sessionSummaryGeneralData?.["visit_scenario"] ||
                        []
                    }
                />
                <FormatArray
                    subIndex={"consultation_medium"}
                    keyName="Consultation Medium"
                    value={
                        sessionSummaryGeneralData?.["medium"] || []
                    }
                />

                <li style={{ fontWeight: "bold" }}>
                    Demographic Details:
                </li>
                <SubFormatArray
                    subIndex={"age"}
                    keyName="Age"
                    value={sessionSummaryGeneralData?.["age"] || []}
                />
                <SubFormatArray
                    subIndex={"gender"}
                    keyName="Gender"
                    value={sessionSummaryGeneralData?.["sex"] || []}
                />

                <SubFormatArray
                    subIndex={"education_level"}
                    keyName="Education Level"
                    value={
                        sessionSummaryGeneralData?.["education"] || []
                    }
                />
                <SubFormatArray
                    subIndex={"employment_status"}
                    keyName="Employment Status"
                    value={
                        sessionSummaryGeneralData?.["employment"] || []
                    }
                />
            </ul>
            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Presenting Complaints
            </span>
            <ul>
                <FormatArray
                    subIndex={"chiefcomplaint"}
                    keyName="Chief Complaint"
                    value={
                        sessionSummaryGeneralData?.[
                        "chief_complaint"
                        ] || []
                    }
                />
                <FormatArray
                    subIndex={"history_of_present_illness"}
                    keyName="History of Present Illness"
                    value={
                        sessionSummaryGeneralData?.[
                        "history_of_present_illness"
                        ] || []
                    }
                />
                <FormatArray
                    subIndex={"changes_since_last_visit"}
                    keyName="Changes Since Last Visit"
                    value={
                        sessionSummaryGeneralData?.[
                        "interval_history"
                        ] || []
                    }
                />
            </ul>
            {/* Common End** */}
            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Medical and Physical Health History
            </span>
            <ul>
                <FormatArray
                    subIndex={"past_surgeries_and_hospitalizations"}
                    keyName="Past Surgeries and Hospitalizations"
                    value={
                        sessionSummaryGeneralData?.[
                        "past_medical_history"
                        ] || []
                    }
                />

                <FormatArray
                    subIndex={"family_medical_history"}
                    keyName="Family Medical History"
                    value={
                        sessionSummaryGeneralData?.[
                        "family_medical_history"
                        ] || []
                    }
                />

                <li style={{ fontWeight: "bold" }}>
                    Medical Conditions:
                </li>
                <SubFormatArray
                    subIndex={"Liver Issues"}
                    keyName="Liver Issues"
                    value={
                        sessionSummaryGeneralData?.["liver_problem"] ||
                        []
                    }
                />
                <SubFormatArray
                    subIndex={"support_systems"}
                    keyName="heart_issues"
                    value={
                        sessionSummaryGeneralData?.["heart_problem"] ||
                        []
                    }
                />
                <SubFormatArray
                    subIndex={"thyroid_problems"}
                    keyName="Thyroid Problems"
                    value={
                        sessionSummaryGeneralData?.[
                        "thyroid_problem"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"adrenal_problems"}
                    keyName="Adrenal Problems"
                    value={
                        sessionSummaryGeneralData?.[
                        "adrenal_problem"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"neurological_conditions"}
                    keyName="Neurological Conditions"
                    value={
                        sessionSummaryGeneralData?.[
                        "neurological_problem"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"autoimmune_inflammatory_disorders"}
                    keyName="Autoimmune/Inflammatory Disorders"
                    value={
                        sessionSummaryGeneralData?.[
                        "inflammatory_autoimmune_problem"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"infections"}
                    keyName="Infections"
                    value={
                        sessionSummaryGeneralData?.["infection"] || []
                    }
                />
                <SubFormatArray
                    subIndex={"support_systems"}
                    keyName="hormonal_imbalances"
                    value={
                        sessionSummaryGeneralData?.[
                        "hormonal_imbalnces"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"gastrointestinal_issues"}
                    keyName="Gastrointestinal Issues"
                    value={
                        sessionSummaryGeneralData?.[
                        "gastrointestinal_problem"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"diabetes_mellitus"}
                    keyName="Diabetes Mellitus"
                    value={
                        sessionSummaryGeneralData?.[
                        "diabetes_mellitus"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"vitamin_deficiency"}
                    keyName="Vitamin Deficiency"
                    value={
                        sessionSummaryGeneralData?.[
                        "vitamin_deficiency"
                        ] || []
                    }
                />

                <FormatArray
                    subIndex={"allergies"}
                    keyName="Allergies"
                    value={
                        sessionSummaryGeneralData?.["allergies"] || []
                    }
                />
                <FormatArray
                    subIndex={"immunization_status"}
                    keyName="Immunization Status"
                    value={
                        sessionSummaryGeneralData?.[
                        "immunization_status"
                        ] || []
                    }
                />
                <FormatArray
                    subIndex={"medication"}
                    keyName="Medication"
                    value={
                        sessionSummaryGeneralData?.[
                        "medication_review"
                        ] || []
                    }
                />
            </ul>

            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Mental Health and Psychiatric History
            </span>
            <ul>
                <FormatArray
                    subIndex={"EmotionalWellBeing"}
                    keyName="Current Mental Health Status"
                    value={
                        sessionSummaryGeneralData?.["mental_health"]
                    }
                />
                <FormatArray
                    subIndex={"consultation_medium"}
                    keyName="Cognitive Functioning"
                    value={
                        sessionSummaryGeneralData?.[
                        "cognitive_functioning"
                        ] || []
                    }
                />

                <FormatArray
                    subIndex={"gender_identity_and_related_issues"}
                    keyName="Gender Identity and Related Issues"
                    value={
                        sessionSummaryGeneralData?.["gender_issue"] ||
                        []
                    }
                />
                <FormatArray
                    subIndex={"previous_psychiatric_problems"}
                    keyName="Previous Psychiatric Problems"
                    value={
                        sessionSummaryGeneralData?.[
                        "past_psychiatric_history"
                        ] || []
                    }
                />
                <FormatArray
                    subIndex={"childhood_trauma_history"}
                    keyName="Childhood Trauma History"
                    value={
                        sessionSummaryGeneralData?.["child_trauma"] ||
                        []
                    }
                />
            </ul>

            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Substance Use History
            </span>
            <ul>
                <FormatArray
                    subIndex={"primary_substance"}
                    keyName="Primary Substance"
                    value={
                        sessionSummaryGeneralData?.["substance"] || []
                    }
                />
                <FormatArray
                    subIndex={"secondary_substances"}
                    keyName="Secondary Substances"
                    value={
                        sessionSummaryGeneralData?.[
                        "secondary_substances"
                        ] || []
                    }
                />
                <li style={{ fontWeight: "bold" }}>
                    Usage Patterns:
                </li>
                <SubFormatArray
                    subIndex={"substance_use_onset"}
                    keyName="Substance Use Onset"
                    value={
                        sessionSummaryGeneralData?.[
                        "substance_start"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"substance_use_onset"}
                    keyName="Frequency and Dosage"
                    value={
                        sessionSummaryGeneralData?.["frequency"] || []
                    }
                />
                <SubFormatArray
                    subIndex={"substance_use_onset"}
                    keyName="Method of Administration"
                    value={
                        sessionSummaryGeneralData?.["administration"] ||
                        []
                    }
                />
            </ul>

            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Family and Social History
            </span>
            <ul>
                <li style={{ fontWeight: "bold" }}>
                    Lifestyle Factors:
                </li>
                <SubFormatArray
                    subIndex={"friends_and_colleagues"}
                    keyName="Physical Activity"
                    value={
                        sessionSummaryGeneralData?.[
                        "physical_activity"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"diet_and_nutrition"}
                    keyName="Diet and Nutrition"
                    value={
                        sessionSummaryGeneralData?.[
                        "diet_and_nutrition"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"sleep_patterns"}
                    keyName="Sleep Patterns"
                    value={
                        sessionSummaryGeneralData?.["sleep_pattern"] ||
                        []
                    }
                />
                <li style={{ fontWeight: "bold" }}>
                    Social History:
                </li>
                <SubFormatArray
                    subIndex={"relationship_status"}
                    keyName="Relationship Status"
                    value={
                        sessionSummaryGeneralData?.["relationship"] ||
                        []
                    }
                />
                <SubFormatArray
                    subIndex={"cognitive_history"}
                    keyName="Friends"
                    value={
                        sessionSummaryGeneralData?.["friends"] || []
                    }
                />

                <SubFormatArray
                    subIndex={"past_coping_mechanisms"}
                    keyName="Support System"
                    value={
                        sessionSummaryGeneralData?.["support_system"] ||
                        []
                    }
                />
                <SubFormatArray
                    subIndex={"gender_identity_and_related_issues"}
                    keyName="Home and Environment Safety"
                    value={
                        sessionSummaryGeneralData?.["safety"] || []
                    }
                />
            </ul>

            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Clinical Examination
            </span>
            <ul>
                <FormatArray
                    subIndex={"physical_examination"}
                    keyName="Physical Examination"
                    value={
                        sessionSummaryGeneralData?.[
                        "physical_examination"
                        ] || []
                    }
                />
                <FormatArray
                    subIndex={"review_of_Systems_(ROS)"}
                    keyName="Review of Systems (ROS)"
                    value={
                        sessionSummaryGeneralData?.[
                        "review_of_systems"
                        ] || []
                    }
                />
                <FormatArray
                    subIndex={"growth_and_development"}
                    keyName="Growth and Development (for Pediatrics Visits)"
                    value={
                        sessionSummaryGeneralData?.[
                        "growth_and_development"
                        ] || []
                    }
                />
            </ul>

            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Diagnostic Findings
            </span>
            <ul>
                <FormatArray
                    subIndex={"physical_examination"}
                    keyName="Health Maintenance (Preventive Care Review)"
                    value={
                        sessionSummaryGeneralData?.[
                        "health_maintenance_review"
                        ] || []
                    }
                />
                <FormatArray
                    subIndex={"review_of_Systems_(ROS)"}
                    keyName="Lab Results"
                    value={
                        sessionSummaryGeneralData?.[
                        "recent_lab_work"
                        ] || []
                    }
                />
            </ul>

            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Clinical Evaluation
            </span>
            <ul>
                <FormatArray
                    subIndex={
                        "problem_list_and_differential_diagnosis"
                    }
                    keyName="Problem List and Differential Diagnosis"
                    value={
                        sessionSummaryGeneralData?.["assessment"] || []
                    }
                />
                <FormatArray
                    subIndex={"risk_factor_assessment"}
                    keyName="Risk Factor Assessment"
                    value={
                        sessionSummaryGeneralData?.[
                        "risk_factor_assessment"
                        ] || []
                    }
                />
                <FormatArray
                    subIndex={"functional_status"}
                    keyName="Functional Status (Impact on Daily Life)"
                    value={
                        sessionSummaryGeneralData?.[
                        "functional_status"
                        ] || []
                    }
                />
            </ul>
            <span
                className="session_report_title"
                style={sessionReportSubtitle}
            >
                Treatment and Follow-Up
            </span>
            <ul>
                <FormatArray
                    subIndex={"diagnosis"}
                    keyName="Diagnosis"
                    value={
                        sessionSummaryGeneralData?.["diagnosis"] || []
                    }
                />
                <FormatArray
                    subIndex={"management_plan"}
                    keyName="Management Plan"
                    value={sessionSummaryGeneralData?.["plan"] || []}
                />
                <li style={{ fontWeight: "bold" }}>
                    Special Considerations:
                </li>
                <SubFormatArray
                    subIndex={"pregnancy_status"}
                    keyName="Pregnancy Status"
                    value={
                        sessionSummaryGeneralData?.["pregnancy"] || []
                    }
                />
                <SubFormatArray
                    subIndex={"comorbid_conditions"}
                    keyName="Comorbid Conditions"
                    value={
                        sessionSummaryGeneralData?.[
                        "secondary_diagnosis"
                        ] || []
                    }
                />
                <SubFormatArray
                    subIndex={"insurance_coverage"}
                    keyName="Insurance Coverage"
                    value={
                        sessionSummaryGeneralData?.["insurance"] || []
                    }
                />
            </ul>
        </>
    )
}

export default NonMentalSessionSummary;